import * as React from 'react';
import { useCallback } from 'react';
import { useSyncExternalStore } from 'use-sync-external-store/shim';
function dispatchStorageEvent(key, newValue, storageType) {
  window.dispatchEvent(new StorageEvent('storage', {
    key: key,
    newValue: newValue,
    storageArea: storageType === 'local' ? window.localStorage : window.sessionStorage
  }));
}
var setStorageItem = function setStorageItem(key, value, storageType) {
  var stringifiedValue = JSON.stringify(value);
  if (storageType === 'local') {
    window.localStorage.setItem(key, stringifiedValue);
  } else {
    window.sessionStorage.setItem(key, stringifiedValue);
  }
  dispatchStorageEvent(key, stringifiedValue, storageType);
};
var removeStorageItem = function removeStorageItem(key, storageType) {
  if (storageType === 'local') {
    window.localStorage.removeItem(key);
  } else {
    window.sessionStorage.removeItem(key);
  }
  dispatchStorageEvent(key, null, storageType);
};
var getStorageItem = function getStorageItem(key, storageType) {
  if (storageType === 'local') {
    return window.localStorage.getItem(key);
  }
  return window.sessionStorage.getItem(key);
};
var storageSubscribe = function storageSubscribe(callback) {
  window.addEventListener('storage', callback);
  return function () {
    return window.removeEventListener('storage', callback);
  };
};
var getStorageServerSnapshot = function getStorageServerSnapshot() {
  throw Error('useLocalStorage is a client-only hook');
};
function useStorage(key, _ref) {
  var schema = _ref.schema,
    storageType = _ref.storageType;
  var getSnapshot = useCallback(function () {
    return getStorageItem(key, storageType);
  }, [key, storageType]);
  var store = useSyncExternalStore(storageSubscribe, getSnapshot, getStorageServerSnapshot);
  var setState = React.useCallback(function (v) {
    var nextState =
    // @ts-expect-error TODO: fix me
    typeof v === 'function' ? v(store ? schema.parse(JSON.parse(store)) : null) : v;
    if (nextState === undefined || nextState === null) {
      removeStorageItem(key, storageType);
    } else {
      setStorageItem(key, nextState, storageType);
    }
  }, [key, store, schema, storageType]);
  var parsed = React.useMemo(function () {
    if (store) {
      return schema.parse(JSON.parse(store));
    }
    return null;
  }, [store, schema]);
  return [parsed, setState];
}
export function useLocalStorage(key, _ref2) {
  var schema = _ref2.schema;
  return useStorage(key, {
    schema: schema,
    storageType: 'local'
  });
}
export function useSessionStorage(key, _ref3) {
  var schema = _ref3.schema;
  return useStorage(key, {
    schema: schema,
    storageType: 'session'
  });
}